import { Action } from '@ngrx/store';
import { type } from '@app/store/util';

import { FileUpload } from '@app/core/interfaces/bewijsstukken';
import { Bewijsstukken, UploadResponse } from '@app/core/interfaces/bewijsstukken';
import { Message } from '@app/core/interfaces';

export const LOAD = type('[Documents] Load Documents');
export const LOAD_SUCCESS = type('[Documents] Load Documents Success');
export const LOAD_ERROR = type('[Documents] Load Documents Error');

export const SUBMIT = type('[Documents] Submit Documents');
export const SUBMIT_SUCCESS = type('[Documents] Submit Documents Success');
export const SUBMIT_ERROR = type('[Documents] Submit Documents Error');

export const UPLOAD = type('[Documents] Upload Documents');
export const UPLOAD_SUCCESS = type('[Documents] Upload Documents Success');
export const UPLOAD_ERROR = type('[Documents] Upload Documents Error');

export const REMOVE_UPLOAD = type('[Documents] Remove Upload Documents');
export const REMOVE_UPLOAD_SUCCESS = type('[Documents] Remove Upload Documents Success');

export class Load implements Action {
    public type: string = LOAD;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadSuccess implements Action {
    public type: string = LOAD_SUCCESS;
    constructor(public payload: { bewijsstukken: Bewijsstukken, dossier_volgnummer: number }) {}
}

export class LoadError implements Action {
    public type: string = LOAD_ERROR;
    constructor(public payload?: any) {}
}

export class Submit implements Action {
    public type: string = SUBMIT;
    constructor(public payload: { dossier_volgnummer: number, upload_enveloppe_volgnummer: number }) {}
}

export class SubmitSuccess implements Action {
    public type: string = SUBMIT_SUCCESS;
    constructor(public payload: { data: any, messages: any, dossier_volgnummer: number}) {}
}

export class SubmitError implements Action {
    public type: string = SUBMIT_ERROR;
    constructor(public payload: { dossier_volgnummer: number, message: Message[] } ) {}
}

export class Upload implements Action {
    public type: string = UPLOAD;
    constructor(public payload: { upload: FileUpload, dossier_volgnummer: number, bewijsstuk_volgnummer: number }) {}
}

export class UploadSuccess implements Action {
    public type: string = UPLOAD_SUCCESS;
    constructor(public payload: { resultaat: UploadResponse, dossier_volgnummer: number, bewijsstuk_volgnummer: number } ) {}
}

export class UploadError implements Action {
    public type: string = UPLOAD_ERROR;

    constructor(public payload?: any) {}
}

export class RemoveUpload implements Action {
    public type: string = REMOVE_UPLOAD;
    constructor(public payload: {
        upload_enveloppe_volgnummer: number,
        upload_enveloppe_item_volgnummer: number,
        dossier_volgnummer: number,
        bewijsstuk_volgnummer: number
    }) {}
}

export class RemoveUploadSuccess implements Action {
    public type: string = REMOVE_UPLOAD_SUCCESS;
    constructor(public payload: {
        upload_enveloppe_volgnummer: number,
        upload_enveloppe_item_volgnummer: number,
        dossier_volgnummer: number,
        bewijsstuk_volgnummer: number
    } ) {}
}

export type Actions
    = Load
    | LoadSuccess
    | LoadError
    | Submit
    | SubmitSuccess
    | SubmitError
    | Upload
    | UploadSuccess
    | UploadError
    | RemoveUpload
    | RemoveUploadSuccess;
